export const REGEX_FILENAME_FROM_URL = new RegExp(/(?:.+\/)([^#?]+)(.*)/);